import React, { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/i18n/I18nContext";
import { formatPrice } from "@/utils/price";
import api from "@/lib/api";

export default function PaymentsTab() {
  const { t, language } = useI18n();
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    api.get("/payments").then(({ data }) => setPayments(data));
  }, []);

  if (payments.length === 0) {
    return <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">{t("dashboard.noOrders")}</div>;
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-border">
      <table className="w-full text-sm">
        <thead className="bg-muted/50 text-left text-xs uppercase text-muted-foreground">
          <tr>
            <th className="p-4">ID</th>
            <th className="p-4">Montant</th>
            <th className="p-4">Statut</th>
            <th className="p-4">Date</th>
            <th className="p-4"></th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.payment_id} className="border-t border-border">
              <td className="p-4 font-mono text-xs">{p.payment_id}</td>
              <td className="p-4 font-semibold">{formatPrice(p.amount, language)}</td>
              <td className="p-4">
                <Badge variant={p.status === "paid" ? "default" : p.status === "refunded" ? "secondary" : "outline"} className="rounded-full">
                  {p.status}
                </Badge>
              </td>
              <td className="p-4 text-muted-foreground">{new Date(p.created_at).toLocaleDateString()}</td>
              <td className="p-4">
                <FileText className="h-4 w-4 text-muted-foreground" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
